
import PaletteProto from "./palette-proto";
import {SkinCommonColorPalette} from "./@type";
import {SkinTheme} from "../../../../layout/ui/@const";

const COMMON_LIGHT: SkinCommonColorPalette = {
    'palette-white'                         : '#FFFFFF',
    'bg-content-plate-on-gray'              : '#FFFFFF',

    // It's pale bg color for Gooddday modern skin menu etc...
    'palette-blue-navbar-pale'              : '#EDF5FF',//'#E8F3FF', //More Contrast
    'palette-violet-navbar-pale'            : '#EDEEFF',//'#F5F1FF',
    'palette-green-navbar-pale'             : '#F0FFED',//'#E5FFEC',
    'palette-turquoise-navbar-pale'         : '#EDFCFF',//'#E6FCFF',

    // Font colors
    'palette-font-default'                  : '#000000',
    'palette-font-less-important'           : '#353E4A',
    'palette-font-not-important'            : '#5E6267',
    'palette-font-disabled'                 : '#ABACAE',
    'palette-font-disabled-on-gray'         : '#A4A7AB',
    'palette-font-no-accent'                : '#787B80',
    'palette-font-no-accent-on-gray'        : '#74787D',
    'palette-font-title'                    : '#394557',
    'palette-font-white'                    : '#FFFFFF',
    'palette-font-black'                    : '#000000',
    'palette-font-on-pale-bg'               : '#353E4A',
    'palette-font-on-color-bg'              : '#FFFFFF',
    'palette-font-less-important-on-pale'   : '#353E4A',
    'palette-font-text-link'                : '#0068FF',
    'temp-palette-font-hmenu'               : '#5E6267',

    // Highlight colors
    'palette-highlight-blue'                : '#ebf3ff',//'#F2FAFF',
    'palette-highlight-blue-light'          : '#FCFDFE',
    'palette-menu-item-hover-color'         : '#f2f5f7',

    'palette-system-action-dark'            : '#044AFF', // '#3481FF',
    'palette-system-action'                 : '#1970ff',
    'palette-system-action-light'           : '#598EF8'
}

const COMMON_DARK: SkinCommonColorPalette = {
    'palette-white'                         : '#1A222C',
    'bg-content-plate-on-gray'              : '#26313E',

    // It's pale bg color for Gooddday modern skin menu etc...
    'palette-blue-navbar-pale'              : '#1f2b46',
    'palette-violet-navbar-pale'            : '#261f46',
    'palette-green-navbar-pale'             : '#19371f',
    'palette-turquoise-navbar-pale'         : '#1f3746',

    // Font colors
    'palette-font-default'                  : '#d9d9d9',
    'palette-font-less-important'           : '#c1c3c6',
    'palette-font-not-important'            : '#a8b0b8',
    'palette-font-disabled'                 : '#787B80',
    'palette-font-disabled-on-gray'         : '#787B80',
    'palette-font-no-accent'                : '#787B80',
    'palette-font-no-accent-on-gray'        : '#BBBBBB',
    'palette-font-title'                    : '#FCFCFC',
    'palette-font-white'                    : '#FFFFFF',
    'palette-font-black'                    : '#000000',
    'palette-font-on-pale-bg'               : '#1A222C',
    'palette-font-on-color-bg'              : '#1A222C',
    'palette-font-less-important-on-pale'   : '#000000',
    'palette-font-text-link'                : '#8ab4f8',
    'temp-palette-font-hmenu'               : '#767a81',

    // Highlight colors
    'palette-highlight-blue'                : '#2e374a',
    'palette-highlight-blue-light'          : '#232f3c',
    'palette-menu-item-hover-color'         : '#37393d',

    'palette-system-action-dark'            : '#3481FF',
    'palette-system-action'                 : '#8ab4f8',
    'palette-system-action-light'           : '#8ab4f8'
}

const DEFAULT_PALETTE = SkinTheme.LIGHT // SkinTheme used like key for palette dictionary

const debug = false
// const debug = "CommonPalette"

export default class CommonPalette extends PaletteProto {

    constructor(currentPalette = DEFAULT_PALETTE) {

        super(currentPalette, DEFAULT_PALETTE)

        // There is no contrast here. Only Dark and Light !!!
        this.palettes = {
            [SkinTheme.LIGHT]   : COMMON_LIGHT,
            [SkinTheme.DARK]    : COMMON_DARK
        }

        this.setPalette(this.currentPalette)

        debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])
    }

    applyDOMCssVariables() {

        // New. This is creating a style tag and setting root variables in it.
        const STYLE_ID = 'dynamic-common-palette-vars'

        const palette = this.palettes[this.currentPalette]

        let styleTag = document.getElementById(STYLE_ID)

        if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.id = STYLE_ID
            document.head.appendChild(styleTag)
        }

        const cssVars = Object.entries(palette)
            .map(([key, value]) => `--${key}: ${value};`)
            .join('\n')

        styleTag.textContent = `
            html:root {
                ${cssVars}
            }
        `

        // Old way
        // const palette = this.palettes[this.currentPalette]
        // const root = document.querySelector(':root');
        //
        // _.map(palette, (value, key)=> {
        //
        //     debug && console.log(debug, 'Common palette: ', key, " ", value)
        //
        //     // @ts-ignore
        //     root.style.setProperty(`--${key}`, value)
        // })
    }

    // lightPalettes() {
    //     return [
    //         SkinTheme.LIGHT, // SkinTheme used like key for palette dictionary
    //     ]
    // }

    // getColorHEX(index:number) {
    //     return this.palettes[this.currentPalette] ? this.palettes[this.currentPalette][`palette-gray-${index}`] : '#000000'
    // }
}
